import "core-js/modules/es.array.filter";
import "core-js/modules/es.string.trim";
import { defineMessages } from 'react-intl';
import { isBlank } from 'helpers/verify';
var PASSWORD_MIN_LENGTH = 8;
var MIN_COMPLEXITY_POINTS = 2;
var messages = defineMessages({
  tooSimple: {
    id: 'validators.password.tooSimple',
    defaultMessage: 'Your password must have at least 8 characters, and include a number or symbol'
  }
});
export var passwordValidator = function passwordValidator(val) {
  var str = "".concat(val).trim();
  var complexityPoints = [/[a-zA-Z]/.test(str), /[0-9]/.test(str), /[^a-zA-Z0-9 ]/.test(str)].filter(function (x) {
    return x;
  }).length;

  if (isBlank(str) || str.length < PASSWORD_MIN_LENGTH || complexityPoints < MIN_COMPLEXITY_POINTS) {
    return messages.tooSimple;
  }
};